import { render, staticRenderFns } from "./addPopup.vue?vue&type=template&id=29965e27&scoped=true&"
import script from "./addPopup.vue?vue&type=script&lang=js&"
export * from "./addPopup.vue?vue&type=script&lang=js&"
import style0 from "./addPopup.vue?vue&type=style&index=0&id=29965e27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29965e27",
  null
  
)

export default component.exports